export default __webpack_public_path__ + "static/media/logo-light.b34db10a.png";